import type { AttachedFile } from '../../types/files';

export const convertAttachmentsToFiles = (attachments: AttachedFile[]) => {
  if (!attachments || !attachments.length) {
    return [];
  }

  return attachments.map(({ fileName, contentType, url }) => ({
    name: fileName,
    fileName,
    type: contentType,
    contentType,
    url,
  }));
};
